module.exports = __webpack_public_path__ + "img/videowiki.1d96dfbc.svg";